import { render, staticRenderFns } from "./UserUpdate.vue?vue&type=template&id=2d12c2f4&scoped=true&"
import script from "./UserUpdate.vue?vue&type=script&lang=js&"
export * from "./UserUpdate.vue?vue&type=script&lang=js&"
import style0 from "./UserUpdate.vue?vue&type=style&index=0&id=2d12c2f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d12c2f4",
  null
  
)

export default component.exports